import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=c0968c22"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=c0968c22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports